import { Controller } from "@hotwired/stimulus";
import { animate } from "animejs";
import { Modal } from 'flowbite';

export default class extends Controller {
    static values = {
        "count": String,
        "name": String,
        "showOnInit": Boolean
    }

    initialize() {
        this.modalTarget = document.getElementById(`${this.nameValue}-modal-${this.countValue}`);
        this.modalContainerTarget = document.getElementById(`${this.nameValue}-modal-container-${this.countValue}`);
        this.modalhideTargets = document.querySelectorAll(`.${this.nameValue}-modal-hide-${this.countValue}`);
        
        if (!this.modalTarget || !this.modalContainerTarget) {
            return;
        }

        this.modalhideTargets.forEach(element => {
            element.addEventListener("click", this.hide.bind(this));
            element.addEventListener("keydown", (event) => {
                if (event.key === 'Enter') {
                    this.hide();
                }
            });
        });

        const options = {
            onHide: () => {
                this.modalTarget.style.opacity = 0;
                this.modalContainerTarget.style.transform = null;
            },
            onShow: () => {
                animate(this.modalTarget, {
                    opacity: 1,
                    duration: 200
                });
                animate(this.modalContainerTarget, {
                    y: "-2rem",
                    duration: 200
                });
                
                if (this.nameValue === "requestInformation" || this.nameValue === "request-information") {
                    const modalTitle = this.modalTarget.querySelector('h2');
                    if (modalTitle) {
                        modalTitle.setAttribute('tabindex', '-1');
                        modalTitle.focus();
                    }
                } else {
                    const firstInput = this.modalTarget.querySelector('input:not([type="hidden"])');
                    if (firstInput) {
                        firstInput.focus();
                    }
                }
            }
        };
        this.modal = new Modal(this.modalTarget, options);

        if (this.showOnInitValue) {
            this.modal.show();
        }
    }

    disconnect() {
        if (this.modal) {
            this.modal.hide();
            this.modalTarget.remove();
        }
    }

    hide() {
        this.modal.hide();
    }

    click() {
        this.modal.show();
    }

    handleKeydown(event) {
        if (event.key === 'Enter') {
            this.click();
        }
    }
}
